const numeral = require("numeral");

const numberFormat = (value, digits = 2) => {
  const _value = Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100;

  let format = "0,0.";
  format += "0".repeat(digits);

  if (_value < 0) {
    return `-${numeral(Math.abs(_value)).format(format)}`;
  }

  return numeral(_value).format(format);
};

module.exports = numberFormat;
